import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../redux/user/user-selector";
import { errorNotification } from "../../../../redux/notifications";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import TemplateHeader from "../../../../components/TemplateHeader/TemplateHeader";
import WelcomeScreen from "../../../../components/WelcomeScreen/WelcomeScreen";
import { PulseLoader } from 'react-spinners';
import "./task-edit-document-modal.scss";

import { GetTaskNEWAPI, GetTaskDocument } from "../../../../services/api/task-api";

const TaskEditDocumentModal = (props) => {
    const { projectID, documentID, assignID, fileName } = props; // also could do this -> props.location.pathname.split('/')[4] but better no expose all data
    const [currDocumentID, setCurrDocumentID] = useState(null);
    const [currFileName, setCurrFileName] = useState("");
    const [onlyOneEffect, setOnlyOneEffect] = useState(true);
    const [isInternalOrProductionEnv, setIsInternalOrProductionEnv] = useState(false);
    const [activatePulseLoader, setActivatePulseLoader] = useState(false);
    const currentUser = useSelector(selectUser);

    const dispatch = useDispatch();

    const checkEnvironment = () => {
        let currentURL = window.location.href;
        let ifExpression = currentURL.includes("qa.triyo") ||
        //currentURL.includes("qa2.triyo") ||
        currentURL.includes("sandbox.triyo") ||
        currentURL.includes("intranet.triyo") ||
        currentURL.includes("demo.triyo") ||
        currentURL.includes("domcap.triyo") ||
        currentURL.includes("rbctest.triyo/") ||
        currentURL.includes("triyoqa.oak.fg.rbc") ||
        currentURL.includes("triyo.oak.fg.rbc") ||
        //currentURL.includes("localhost:3000") || //Testing here the Footer. According to the TAD-1514, internal and production environments have disabled footer
        currentURL.includes("localhost:44339");

        setIsInternalOrProductionEnv(!!ifExpression);
    }

    // Data fetching for selected document -> here we are going to download file //Tested working pptx and docx
    const fetchTaskAndDownloadDocument = async () => {
        // Get task information
        await GetTaskNEWAPI(assignID)
            .then(async(taskinfo) => {
                if (taskinfo) {
                    if (taskinfo.DocumentTypeId === 1) {
                        setCurrDocumentID(taskinfo.WordDocumentFileId);
                        await GetTaskDocument(taskinfo.WordDocumentFileId, fileName)
                            .then(async(result) => {}, (error) => setActivatePulseLoader(false))
                    } else if (taskinfo.DocumentTypeId === 3) {
                        setCurrDocumentID(taskinfo.DocumentPowerpoint[0].FileNameId);
                        await GetTaskDocument(taskinfo.DocumentPowerpoint[0].FileNameId, fileName)
                            .then(async(result) => {}, (error) => setActivatePulseLoader(false))
                    }
                }
            }, (error) => setActivatePulseLoader(false))
        setActivatePulseLoader(false);
    };

    // Data fetching for selected document -> here we are going to download file //Tested working pptx and docx
    const fetchDownloadTaskDocument = async() => {
        setActivatePulseLoader(true);
        if (currDocumentID) {
            await GetTaskDocument(currDocumentID, currFileName)
                .then(async(result) => { setActivatePulseLoader(false); }, (error) => setActivatePulseLoader(false))
        }
    }

    const initDownload = async () => {
        checkEnvironment();
        setActivatePulseLoader(true);
        setCurrDocumentID(documentID);
        setCurrFileName(fileName);
        if (documentID && fileName) {
            if (documentID > 0 && fileName.length > 0) {
                await fetchTaskAndDownloadDocument();
            }
        } else {
            setActivatePulseLoader(false);
            dispatch(errorNotification({
                header: "Error downloading document",
                message: "Please try again or click on the download option",
            }));
        }
    }

    useEffect(() => {
        if (onlyOneEffect === true) initDownload();
        return () => {
            setOnlyOneEffect(false);
        }
    }, [onlyOneEffect])

    return (
        <Modal show={props.show} contentClassName="modal-styles welcome-layout" className="document-collaboration-modal">
            {
                activatePulseLoader &&
                <div className = "pulse-loader" >
                    <PulseLoader / >
                </div>
            }
            <Modal.Header>
                <TemplateHeader
                    heading="Create Task"
                    subHeading="Document Collaboration"
                    onClose={() => props.onHide()}
                />
            </Modal.Header>
            <Modal.Body className="action-popup">
                <Container>
                    <WelcomeScreen documentName={currFileName} onClick={ (e) => fetchDownloadTaskDocument() }/>
                </Container>
            </Modal.Body>
            {
            !isInternalOrProductionEnv &&
            <Modal.Footer style={{ borderTop: "1px solid lightgray", height: "60px"}}>
                <Container>
                    <Row>
                        <span className="footer-text">Don't have TRIYO's Add-ins yet?&nbsp;
                            <a target="_blank" href="https://appsource.microsoft.com/en-us/product/office/WA200003574?src=office">
                                Get them from the Microsoft Store
                            </a>
                        </span>
                    </Row>
                </Container>
            </Modal.Footer>
            }
        </Modal>
    );
}

export default TaskEditDocumentModal;